<template>
  <select
    v-model="selectedIndustry"
    name="industry-average"
    class="industry-average"
    :disabled="industrySelectState"
    @change="onChange"
  >
    <option
      v-for="(industry, index) in industryListSorted"
      :key="index"
      :value="industry.sectorIndex"
      :disabled="isOptionDisabled(industry)"
    >
      {{ industryLabel(industry) }}
    </option>
  </select>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'RareIndustrySelect',
  data() {
    return {
      selectedIndustry: '',
    };
  },
  computed: {
    ...mapGetters({
      industryList: 'clientByIndustryLists',
      industrySelectState: 'industrySelectState',
      clientOrRareMode: 'clientOrRareMode',
    }),
    industryListSorted() {
      this.sortIndustryList();
      return this.industryList;
    },
  },
  created() {
    if (this.$store.getters.industryAverage === '') {
      this.$store.commit('updateIndustryAverage', '0');
      this.selectedIndustry = '0';
    }
  },
  mounted() {
    this.selectedIndustry = this.$store.getters.industryAverage;
    // console.log(this.selectedIndustry);
  },
  methods: {
    onChange() {
      this.$store.commit('updateIndustryAverage', this.selectedIndustry);
      this.$emit('industryAverageChange', this.selectedIndustry);
    },
    sortIndustryList() {
      this.industryList.sort((a, b) => (a.industryName).localeCompare(b.industryName));
    },
    industryLabel(industry) {
      const { sectorIndex, industryName, numberOfClients } = industry;
      return (this.clientOrRareMode === 'rare' ? `${industryName} ${(sectorIndex === 0 ? '' : `(${numberOfClients})`)}` : industryName);
    },
    isOptionDisabled(industry) {
      const { sectorIndex, numberOfClients } = industry;
      let isDisabled;

      if (sectorIndex === 0) {
        isDisabled = false;
      } else {
        isDisabled = (sectorIndex === '0') || (numberOfClients === 0 && this.clientOrRareMode === 'rare');
      }

      return isDisabled;
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .industry-average {
    width: 210px;
    margin-left: 15px;
  }

</style>
